import { makeAutoObservable } from 'mobx';

export type DictionaryItem<T extends number | string = string> = { id: T; name: string };

export class Dictionary<T extends number | string = string> {
  private _items: DictionaryItem<T>[];

  constructor(items: DictionaryItem<T>[]) {
    this._items = items;
    makeAutoObservable(this);
  }

  public get items() {
    return this._items;
  }

  public find(id: string) {
    return this._items.find((item) => item.id === id);
  }
}
